import React from "react";
import { Formik, Form } from "formik";
import { useNavigate } from "react-router-dom";
import { Button, FormikInput, UploadFile, Textarea } from "../../../ui";
import { addPropanePromotionInitialValues } from "../../../../utils/formik/initialValues";
import { addPropanePromotionValidationSchema, editPropanePromotionValidationSchema } from "../../../../utils/formik/validationSchema";
import styles from "../addNewLocationForm/style.module.scss";

const AddPropanePromotionForm = (props) => {
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate("/dashboard/propane-promotions");
  };

  return (
    <Formik
      initialValues={
        props.formInitialValues || {
          ...addPropanePromotionInitialValues,
        }
      }
      validationSchema={props.formInitialValues ? editPropanePromotionValidationSchema : addPropanePromotionValidationSchema}
      enableReinitialize={true}
      onSubmit={(values) => {
        if (props.formInitialValues) {
          const updatedDataObj = {};
          const keys = Object.keys(props.formInitialValues);
          keys.map((key) => {
            if (props.formInitialValues[key] !== values[key]) {
              return (updatedDataObj[key] = values[key]);
            }
            return false;
          });
          props.updateData({
            ...updatedDataObj,
            id: values.id,
          });
        } else {
          props.data(values);
        }
      }}
    >
      {({
        errors,
        touched,
        getFieldProps,
        setFieldValue,
        handleBlur,
        isValid,
        dirty,
      }) => (
        <Form className={styles.addLocationForm}>
          <section>
            <div>
              <FormikInput
                type="text"
                name="name"
                label="Promotion Name*"
                placeholder="Enter promotion name (max 100 characters)"
                formikProps={getFieldProps("name")}
                formikTouch={touched.name}
                formikErrors={errors.name}
                style={
                  touched.name && errors.name ? { borderColor: "red" } : null
                }
              />
            </div>
            <div>
              <Textarea
                name="description"
                label="Description*"
                placeholder="Enter promotion description (max 500 characters)"
                formikProps={getFieldProps("description")}
                formikTouch={touched.description}
                formikErrors={errors.description}
                style={
                  touched.description && errors.description
                    ? { borderColor: "red" }
                    : null
                }
              />
            </div>
            <div>
              <FormikInput
                type="date"
                name="effective_date"
                label="Effective Date*"
                formikProps={getFieldProps("effective_date")}
                formikTouch={touched.effective_date}
                formikErrors={errors.effective_date}
                style={
                  touched.effective_date && errors.effective_date
                    ? { borderColor: "red" }
                    : null
                }
              />
              <FormikInput
                type="date"
                name="expiration_date"
                label="Expiration Date*"
                formikProps={getFieldProps("expiration_date")}
                formikTouch={touched.expiration_date}
                formikErrors={errors.expiration_date}
                style={
                  touched.expiration_date && errors.expiration_date
                    ? { borderColor: "red" }
                    : null
                }
              />
            </div>
            <div>
              <UploadFile
                label="Promotion Image*"
                name="image"
                onChange={(e) => {
                  setFieldValue("image", e.currentTarget.files[0]);
                  handleBlur(e); // Mark field as touched
                }}
                formikTouch={touched.image}
                formikErrors={errors.image}
                style={
                  touched.image && errors.image ? { borderColor: "red" } : null
                }
              />
            </div>
            <div>
              <FormikInput
                type="text"
                name="link"
                label="External Link*"
                placeholder="Enter valid URL (e.g., https://example.com)"
                formikProps={getFieldProps("link")}
                formikTouch={touched.link}
                formikErrors={errors.link}
                style={
                  touched.link && errors.link
                    ? { borderColor: "red" }
                    : null
                }
              />
            </div>
            <div className={styles.bottomRow}>
              <div>
                <Button
                  type="submit"
                  label={props.loading ? "Saving..." : "Save"}
                  disabled={props.loading || !(isValid && dirty)}
                  primary
                  style={{ maxWidth: "20rem" }}
                />
                <Button
                  type="button"
                  label="Cancel"
                  disabled={props.loading}
                  onClick={handleCancel}
                  secondary
                  style={{ maxWidth: "20rem" }}
                />
              </div>
            </div>
          </section>
        </Form>
      )}
    </Formik>
  );
};

export default AddPropanePromotionForm;
